jQuery(document).ready(function($) {
    
	$('.popup__close').click(function(e) {
		e.preventDefault();
		var $parent = $(this).parents('.popup');
		$('.popup-wrapper').removeClass('active');
		$parent.removeClass('active');
	});

	// Show Newsletter Popup
	// if(!Cookies.get('newsletter')) {
	// 	setTimeout(function() {
	// 		$('.popup-wrapper').addClass('active');
	// 		$('.popup.newsletter-popup').addClass('active');
	// 		Cookies.set('newsletter', 'true', { expires: 31 });
 //  		}, 5000);
	// }
 
});
